import React, { useEffect, useState } from "react";
import App from "../App";
import ButtonAppBar from "../ButtonAppBar";
import CollapsibleTable from "./CollapsibleTable";
import TimeSlotCalendar from "./TimeSlotCalendar";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Container, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

function Main() {
  const [selectedSlotData, setSelectedSlotData] = useState(null);
  const history = useNavigate();
  const timeButton = () => {
    history("/reservation/insert");
  };
  const handleSlotSelect = (slotInfo) => {
    setSelectedSlotData(slotInfo);
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("id");
    if (!isLoggedIn) {
      history("/");
    }
  }, [history, sessionStorage.getItem("id")]);
  const typographyStyle = {
    ml: windowWidth < 768 ? 0 : 8,
    mr: windowWidth < 768 ? "0px" : "5px",
  };
  const gridStyle = {
    width: windowWidth < 768 ? "95%" : "100%",
    height: windowWidth < 768 ? 550 : 820,
    ml: windowWidth < 768 ? 1 : 1,
  };

  const timeStyle = {
    marginTop: windowWidth < 768 ? "20px" : "0px",
  };

  return (
    <Box>
      <ButtonAppBar />
      <Container
        maxWidth={1600}
        sx={{
          ...typographyStyle,
          mt: 10,
          mb: 10,
          display: "flex",
          flexDirection: "column",
          p: 0,
        }}
      >
        <Grid container spacing={4}>
          {windowWidth > 400 ? (
            <Grid item xs={12} md={8} lg={6}>
              <Paper
                sx={{
                  ...gridStyle,
                  p: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography sx={{ marginLeft: 3, fontSize: 13 }}>
                  - 신청자 계정으로 예약된 회의실은 삭제 및 재신청 가능.
                </Typography>
                <Typography sx={{ marginLeft: 3, fontSize: 13 }}>
                  - 회의실 사용 일정 조율이 필요한 경우 희망자간에 일정 조율 후
                  기존 일정 삭제 및 재신청.
                </Typography>
                <Typography
                  sx={{ marginLeft: 3, fontSize: 13, marginBottom: 3 }}
                >
                  - 회의실 예약은 금일로부터 일주일 전까지 가능.
                </Typography>
                <CollapsibleTable data={selectedSlotData} />
                <Typography
                  sx={{
                    marginLeft: 3,
                    fontSize: 14,
                    fontWeight: 600,
                    color: "red",
                    mt: 1,
                    textDecoration: "underline",
                  }}
                >
                  * T1 2F 교육장은 항공사 사무실 개조로 인해 폐쇄되어 예약
                  불가합니다.
                </Typography>
              </Paper>
            </Grid>
          ) : (
            ""
          )}

          <Grid item xs={12} md={8} lg={5.5}>
            <Paper
              sx={{
                ...gridStyle,
                p: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TimeSlotCalendar onSlotSelect={handleSlotSelect} />
              {windowWidth < 768 ? (
                <Button
                  sx={timeStyle}
                  onClick={(e) => {
                    timeButton();
                    e.stopPropagation();
                  }}
                  variant="contained"
                >
                  예약하기
                </Button>
              ) : (
                ""
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
export default Main;
